import { Controller } from "@hotwired/stimulus";

const removeFormattingFromNumber = (number) => {
  let retVal = ''
  if (number) {
    retVal = number.toString().replace(/\D/g, '')
  }

  return retVal
}

export default class extends Controller {
  static targets = ["button", "input"]

  static values = {
    isValid: Boolean
  };

  connect() {
    const input = this.hasInputTarget ? this.inputTarget : this.element.querySelector("[data-action='input->format-phone#format']")

    if (input) {
      this.format({
        target: input
      })
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  inputTargetConnect() {
    this.format({
      target: this.inputTarget
    })
  }

  format(event) {
    let retPhone = '';
    let strippedPhone = removeFormattingFromNumber(event.target.value);

    if (strippedPhone.slice(0, 1) === '1') {
      strippedPhone = strippedPhone.slice(1);
    }

    for (let i = 0; i < strippedPhone.length && i < 10; i++) {
      let character = strippedPhone.charAt(i);
      if (i === 0) {
        let prefix = '+1 (';
        retPhone += prefix + character;
      } else if (i === 3) {
        retPhone += ') ' + character;
      } else if (i === 6) {
        retPhone += '-' + character;
      } else {
        retPhone += character;
      }
    }

    this.isValidValue = retPhone.length === 17
    event.target.value = retPhone
  }

  isValidValueChanged() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = !this.isValidValue
      if (this.isValidValue) {
        this.buttonTarget.classList.remove("btn--disabled")
      }
    }
  }
}
